module.exports = __webpack_public_path__ + "static/media/blocoL1img1.db93c88d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/EVisual/blocoL1img1.jpg
// module id = 151
// module chunks = 0